;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/org/:slug/batch/:uuid\",\"regex\":\"^/org/([^/]+)/batch/([^/]+)$\",\"paramNames\":[\"slug\",\"uuid\"]},{\"path\":\"/org/:slug/dashboard\",\"regex\":\"^/org/([^/]+)/dashboard$\",\"paramNames\":[\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admin\"},{\"path\":\"/dashboard\"},{\"path\":\"/devops/auth-test\"},{\"path\":\"/devops/auth-test/admin\"},{\"path\":\"/devops/auth-test/compliance\"},{\"path\":\"/devops/auth-test/marketing\"},{\"path\":\"/devops/sentry-example-page\"},{\"path\":\"/devops/test-user-activity\"},{\"path\":\"/logout\"},{\"path\":\"/no-org\"}]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from "@sentry/nextjs";

if (
  process.env.NODE_ENV === "production" ||
  !!process.env.NEXT_PUBLIC_VERCEL_ENV
) {
  Sentry.init({
    dsn: "https://98eae12012603e0055d547db907593db@o1028474.ingest.us.sentry.io/4509949445144582",

    integrations: [Sentry.replayIntegration()],

    tracesSampleRate: 1,
    enableLogs: true,

    replaysSessionSampleRate: 0.1,

    replaysOnErrorSampleRate: 1.0,

    debug: false,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
